<small *ngFor="let error of errores">
    <span class="text-danger " *ngIf="control.hasError(error.error) 
                                          && (control.touched)">
        {{error.mensaje}}
        <span *ngIf="control.hasError('server')">
            {{control.errors['server']}}
        </span>
    </span>
</small>